import { render } from "./GrowthVelocityChart.vue?vue&type=template&id=15544973&scoped=true"
import script from "./GrowthVelocityChart.vue?vue&type=script&lang=js"
export * from "./GrowthVelocityChart.vue?vue&type=script&lang=js"

import "./GrowthVelocityChart.vue?vue&type=style&index=0&id=15544973&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15544973"]])

export default __exports__